import { render, staticRenderFns } from "./platform-access.vue?vue&type=template&id=778d3a54&scoped=true&"
import script from "./platform-access.vue?vue&type=script&lang=js&"
export * from "./platform-access.vue?vue&type=script&lang=js&"
import style0 from "./platform-access.vue?vue&type=style&index=0&id=778d3a54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778d3a54",
  null
  
)

export default component.exports